<div class="infor" *ngIf="fackbookPost">
    <p class="instagram"><a href="https://www.facebook.com/billyinca" target="new">
        <span class="icon">F</span>
        Facebook</a>
    </p>
</div>
<div class="facebook-post" *ngIf="fackbookPost">
    <div class="row">
        <div class="col-lg-3 col-xs-6 col-md-3 col-sm-6 item"  *ngFor="let media of fackbookPost">
            <div class="card">
                <div class="card-image">
                    <a href="{{media.post_url}}" target="new">
                        <img src="{{media.photos[0].alt_sizes[4].url}}" class="card-img-top" alt="{{media.blog.description}}">
                    </a>                    
                </div>
                <div class="card-body">
                    <div class="body-wrapper">                                
                    <div class="siteTitle">
                        <span>{{media.blog_name}}</span>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </div>    
</div>